import { Tabs as MaterialTabs, Tab } from "@mui/material";
import { TabsProps } from "./types";
import "./Tabs.style.scss"

const Tabs = ({ data, value, onChange, className }: TabsProps) => {
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <MaterialTabs value={value} onChange={onChange} className={`${className} ds-tabs`}>
      {data.map((tab, i) => (
        <Tab
          key={tab.value}
          label={tab.label}
          value={tab.value}
          disabled={tab.disabled}
          {...a11yProps(i)}
        />
      ))}
    </MaterialTabs>
  );
};

export default Tabs;
